import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.scss';
import Card from 'components/Card';
import UploadTableRow from './uploadTableRow';
import { can } from '../../../services';

const UploadsTable = (props) => {
  const canDownload = () => !props.isPayRate || can(props.role, 'manage', 'pay_rate');
  const rows = props.data.map(rowData => (<UploadTableRow
    key={rowData.id}
    rowData={rowData}
    canDownload={canDownload()}
    crews={props.crews}
    isPayRate={props.isPayRate}
  />));
  const uploadFile = (props.uploadText ? (<div className={styles.uploadFileWrapper}>
    <button onClick={props.handleUpload} className={styles.button}>
      {props.uploadText}
    </button>
  </div>) : null);
  return (<Card className={styles.uploadsTable}>
    {uploadFile}
    <table>
      <thead>
        <tr>
          {canDownload() && <th className={styles.downloadColumn}>
            {props.downloadColumnName}
          </th>}
          {props.crews && <th>Belongs To</th>}
          <th>Uploaded By</th>
          <th>Uploaded On</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </table>
  </Card>);
};

UploadsTable.defaultProps = { isPayRate: false, crews: null };

UploadsTable.propTypes = {
  role: PropTypes.string.isRequired,
  data: PropTypes.array,
  isPayRate: PropTypes.bool,
  downloadColumnName: PropTypes.string,
  uploadText: PropTypes.string,
  handleUpload: PropTypes.func,
  crews: PropTypes.array,
};

export default UploadsTable;



// WEBPACK FOOTER //
// ./client/app/shared/components/UploadsTable/index.jsx